import { ReactElement } from "react";

import VippsButton from "./vippsLogo.svg?react";

export default function VippsLogoButton(styles: any): ReactElement {
    return <VippsButton style={styles} />;
}
